import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M15.6875 9.75C15.6875 10.1328 15.3867 10.4062 15.0313 10.4062L4.96875 10.4062C4.58594 10.4062 4.3125 10.1328 4.3125 9.75C4.3125 9.39453 4.58594 9.09375 4.96875 9.09375L15.0313 9.09375C15.3867 9.09375 15.6875 9.39453 15.6875 9.75Z"
	})
});
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
